import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdvancedSearchModel } from '@app/components/controls/utilities/models/advanced-search-model';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { DropDownModel } from '@app/components/controls/utilities/models/drop-down-model';
import { FileUploadModel } from '@app/components/controls/utilities/models/file-upload-model';
import { TextAreaModel } from '@app/components/controls/utilities/models/text-area-model';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { BuilderService } from '@app/components/controls/utilities/services/builder.service';
import { BaseService } from '@app/system/services/base.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from '../utilities/services/api.service';
import { ApiService as ResourceApiService } from '@app/modules/resource/utilities/services/api.service';
import { PopupComponent } from '@app/components/popup/popup.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UntypedFormGroup } from '@angular/forms';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { AppInitializerService } from '@app/app-initializer.service';
import { HandleBarPipe } from '@app/system/pipes/handle-bar/handle-bar.pipe';
import { AssessmentFormsComponent } from '@app/modules/assessment/assessment-forms/assessment-forms.component';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { EventCard } from '@app/components/widget/event-card/event-card.component';
import { PlaylistCard } from '@app/components/widget/playlist-card/playlist-card.component';
import { QuestionCard } from '@app/components/widget/question-card/question-card.component';
import { AssignmentUpdateComponent } from '@app/modules/assignment/assignment-update/assignment-update.component';
import { ResourceFormsComponent } from '@app/modules/resource/resource-forms/resource-forms.component';
import { ApiService as PeopleApiService } from '@app/modules/people/utilities/services/api.service';
import { CourseProgressComponent } from '../course-progress/course-progress.component';
import { ApiService as ChannelsApiService } from '@app/modules/channels/utilitites/services/api.service';
import { CheckBoxModel } from '@app/components/controls/utilities/models/check-box-model';


@Component({
	selector: 'app-course-forms',
	templateUrl: './course-forms.component.html',
	styleUrls: ['./course-forms.component.scss']
})
export class CourseFormsComponent implements OnInit, AfterViewInit {

	@ViewChild('formElement') set setFocus(content: ElementRef) {
		if (this.action === 'enrollmentUsers' && content && this.detectDevice.resolutionState$.value.deviceType === 'desktop') {
			const el: HTMLElement = content.nativeElement.querySelector('#search');
			if (el) {
				const parentEl: HTMLElement = (el.firstChild as HTMLElement);
				parentEl.getElementsByTagName('input')[0].focus();
			}
		}
	}

	@ViewChild('infoTextEl') infoTextEl: ElementRef;

	action: 'enrollmentUsers' | 'moderate' | 'addCourse' | 'editCourse' | 'addEnrollUsers' | 'addModule' | 'editModule' | 'chooseContentType'
		| 'addActivity' | 'nominate' | 'enrollCourse' | 'generateCertificate' | 'viewCertificate' | 'viewAssesmentResult' | 'viewScormReport';
	formFields: any = [];
	config = { fxFlex: 100 };
	formObject;
	submitDisable = true;
	popupRef;
	record;
	info = '';
	title: string = '';
	referenceTitle: string = '';
	tabIndex = 0;
	search: AdvancedSearchModel;
	pageNumber = 1;
	limit = 10;
	usersCount = 0;
	users = [];
	loader = false;
	skillField: any = [];
	preRequisiteField: any = [];
	currentUser;
	languageCode = 'en';
	formObjectData = {
		form: null,
		fields: []
	};
	clearTimeout;
	controlValue;
	resourceDetail: any;
	formPopup = true;
	form: UntypedFormGroup;
	contentType = [];
	selectedContentType;
	activityData = [];
	deviceDetails;
	selectedResources = [];
	resourceField = [];
	certificationDate;
	showNewResource: boolean = false;
	profileCertificate: boolean = false;
	viewResultDetails;
	userData;
	assesmentTestDetails: any;
	testResultDetails = [];
	scoredPercetageAssesment;
	completionDate;
	scoredPercentage;
	visibilityField = [];

	viewScormData;
	scormReport;
	barColor = '0 145 234';
	tableOutlineColor = '238 238 238';
	scormScore;
	ruleData;

	constructor(
		public locale: LocaleService,
		private apiService: ApiService,
		public detectDevice: DetectDeviceService,
		private controlBuild: BuilderService,
		public gfService: GlobalFunctionService,
		private baseService: BaseService,
		private resourceApiService: ResourceApiService,
		private popup: MatDialog,
		private globalApiService: GlobalApiService,
		private handleBarPipe: HandleBarPipe,
		private peopleApiService: PeopleApiService,
		private appInit: AppInitializerService,
		private channelsApiService: ChannelsApiService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.deviceDetails = this.detectDevice.fingerPrint;
		if (!['enrollmentUsers', 'chooseContentType', 'generateCertificate', 'viewAssesmentResult'].includes(this.action)) {
			this.baseService.formView = true;
		}
		if (this.action === 'addCourse' || this.action === 'editCourse') {
			if (this.action === 'addCourse') {
				this.title = this.locale.translate('create_course');
			} else {
				this.title = this.locale.translate('edit_course');
			}
			this.popupRef.componentInstance.popupLoader = true;
			const title: TextBoxModel = {
				fieldColumn: 'title',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('title'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('title')
			};
			const description: TextAreaModel = {
				fieldColumn: 'description',
				additionalMetaData: {
					maxChar: 500,
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				validationRegex: null,
				fieldCaption: this.locale.translate('desc'),
				fieldHelpText: null,
				fieldOrder: 2,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('desc')
			};

			const thumbnail: FileUploadModel = {
				fieldCaption: this.locale.translate('cover_image'),
				fieldColumn: 'thumbnail',
				validationMessage: this.locale.translate('invalid_file'),
				fieldOrder: 3,
				fieldType: 'fileUpload',
				fieldHelpText: null,
				fieldPlaceholder: this.locale.translate('drop_click_image_upload'),
				isRequired: true,
				isHidden: false,
				additionalMetaData: {
					showLabel: false,
					fileSize: '10MB',
					supportedType: ['.jpg', '.jpeg', '.png', '.gif'],
					drag: true
				},
				isReadonly: false,
				value: null
			};

			const durationInhrs: TextBoxModel = {
				fieldColumn: 'durationInhrs',
				additionalMetaData: {
					max: 100,
					fieldConfig: { appearance: 'standard' },
					showLabel: true
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: '^([0-9]{1,2}(\:[0-5][0-9])?)$', //'^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$',
				fieldCaption: this.locale.translate('duration'),
				fieldHelpText: null,
				fieldOrder: 4,
				validationMessage: this.locale.translate('enter_valid_time_format'),
				fieldPlaceholder: this.locale.translate('time_format')
			};

			const minScoreForCertification: TextBoxModel = {
				fieldColumn: 'minScoreForCertification',
				additionalMetaData: {
					max: 100,
					fieldConfig: { appearance: 'standard' },
					showLabel: true
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'number',
				validationRegex: null,
				fieldCaption: this.locale.translate('min_score_for_certification'),
				fieldHelpText: null,
				fieldOrder: 5,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('min_score_for_certification')
			};

			const skills: AutoCompleteModel = {
				fieldColumn: 'skills',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					defaultWeightage: 1,
					minWeightage: 1,
					showHelp: true
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('skills_covered_course'),
				fieldOrder: 6,
				preDefined: false,
				fieldPlaceholder: this.locale.translate('skills_covered_course'),
				type: 'weightage'
			};

			const prerequisiteSkills: AutoCompleteModel = {
				fieldColumn: 'prerequisiteSkills',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					defaultWeightage: 1,
					minWeightage: 1,
					showHelp: true
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('skills_required_to_enroll'),
				fieldOrder: 7,
				preDefined: false,
				fieldPlaceholder: this.locale.translate('skills_required_to_enroll'),
				type: 'weightage'
			};

			// const enforcePrequisites: CheckBoxModel = {
			// 	fieldColumn: 'enforcePrequisites',
			// 	additionalMetaData: {
			// 		showLabel: true
			// 	},
			// 	fieldType: 'checkBox',
			// 	isHidden: false,
			// 	isReadonly: false,
			// 	isRequired: false,
			// 	options: [{
			// 		key: true,
			// 		value: this.locale.translate('enforce_prerequisites')
			// 	}],
			// 	fieldCaption: null,
			// 	fieldOrder: 8
			// };
			const enrollment: DropDownModel = {
				fieldColumn: 'enrolment',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('enrollment'),
				fieldPlaceholder: this.locale.translate('enrollment'),
				value: null,
				fieldOrder: 9
			};
			enrollment.options = [
				{
					key: 'anyone',
					value: this.locale.translate('open_for_all')
				},
				{
					key: 'approval',
					value: this.locale.translate('by_request')
				},
				{
					key: 'byAssignment',
					value: this.locale.translate('by_assigment_only')
				}
			];


			const channel: AutoCompleteModel = {
				fieldColumn: 'channel',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('channels'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_channels')
			};

			if (this.currentUser.weightageData) {
				skills.additionalMetaData.maxWeightage = this.currentUser.weightageData.map((data) => {
					return {
						key: data.termID,
						value: data.term,
						weightage: data.index,
						description: data.attributes.description
					};
				});
				prerequisiteSkills.additionalMetaData.maxWeightage = this.currentUser.weightageData.map((data) => {
					return {
						key: data.termID,
						value: data.term,
						weightage: data.index,
						description: data.attributes.description
					};
				});
			}

			// this.loadMySkills(prerequisiteSkills);
			// this.loadMySkills(skills);
			if (this.action === 'editCourse') {
				this.popupRef.componentInstance.popupLoader = true;
				const headers: any = {
					lanCode: sessionStorage.getItem('locale') || 'en'
				};
				this.resourceApiService.detail(this.record.resourceID, headers).subscribe(
					(response) => {
						if (response) {
							this.resourceDetail = response;
							title.value = response.title;
							description.value = response.description;
							if (response.resource) {
								thumbnail.value = {
									name: response.resource.thumbnail
								};
								thumbnail.additionalMetaData.thumbnail = response.resource.thumbnail;
							}
							if (response.infoFields && response.infoFields.course) {
								durationInhrs.value = this.gfService.formatTime((Number(response.infoFields.course.courseDurationInHrs * 60)), 'hh:mm');
								minScoreForCertification.value = response.infoFields.course.minScoreForCertification;
								if (response.infoFields.course.prerequisiteSkills && response.infoFields.course.prerequisiteSkills.length) {
									prerequisiteSkills.selectedValue = response.infoFields.course.prerequisiteSkills.map(resp => {
										return {
											key: resp.skill,
											value: resp.skillName,
											isDelete: false,
											isAdd: true,
											weightage: resp.skillLevel
										};
									});
									prerequisiteSkills.value = prerequisiteSkills.selectedValue;
								}
								// enforcePrequisites.value = [response.infoFields.course.enforcePrerequisites];
								enrollment.value = response.infoFields.course.enrolment;
							}
							if (response.skills && response.skills.length) {
								skills.selectedValue = response.skills.map(resp => {
									return {
										key: resp.skill.key,
										value: resp.skill.value,
										isDelete: false,
										isAdd: true,
										weightage: resp.skillLevel
									};
								});
								skills.value = skills.selectedValue;
							}
						}
					},
					(error) => {
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
					}
				)
					.add(() => {
						this.formFields = [
							title,
							description,
							thumbnail,
							durationInhrs,
							minScoreForCertification
						];
						this.skillField = [skills];
						this.preRequisiteField = [prerequisiteSkills, enrollment];
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.formFields = [
					title,
					description,
					thumbnail,
					durationInhrs,
					minScoreForCertification
				];
				this.skillField = [skills];
				this.preRequisiteField = [prerequisiteSkills, enrollment];
				this.loadChannel(channel);
				this.visibilityField = [channel];
				this.popupRef.componentInstance.popupLoader = false;
			}

			this.submitDisable = false;
		} else if (this.action === 'enrollmentUsers') {
			this.search = {
				additionalMetaData: {
					filter: []
				},
				category: null,
				fieldColumn: 'search',
				fieldType: 'advancedSearch',
				isHidden: false,
				isReadonly: false,
				fieldCaption: '',
				fieldHelpText: '',
				fieldHelpTextLong: '',
				fieldOrder: 1,
				fieldPlaceholder: 'Search',
				isRequired: false,
				options: [],
				selectedValue: [],
				type: 'classic'
			};
			this.formFields = [this.search];
			const data = this.controlBuild.formGroupBuilder(this.formFields);
			this.form = data;
			this.title = this.record.title;
			this.getUsers();
			this.submitDisable = false;
		} else if (this.action === 'moderate') {
			this.title = this.locale.translate('moderate');
			this.popupRef.componentInstance.popupLoader = true;
			const remarks: TextAreaModel = {
				fieldColumn: 'moderatorRemarks',
				additionalMetaData: {
					maxChar: 500,
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				validationRegex: null,
				fieldCaption: this.locale.translate('remarks'),
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('remarks')
			};
			this.formFields = [remarks];
			this.popupRef.componentInstance.popupLoader = false;
			this.submitDisable = false;
		} else if (this.action === 'addEnrollUsers') {
			this.title = this.locale.translate('enroll_users');
			if (this.record && this.record.resourceAction && this.record.resourceAction.assign) {
				this.info = this.locale.translate('if_you_wish_to_enroll_users_as_a_batch_desc');
			}
			this.popupRef.componentInstance.popupLoader = true;
			const enrolUserID: AutoCompleteModel = {
				fieldColumn: 'enrolUserID',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('select_users'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('select_users')
			};

			this.formFields = [enrolUserID];
			this.popupRef.componentInstance.popupLoader = false;
			this.submitDisable = false;
		} else if (this.action === 'addModule' || this.action === 'editModule') {
			if (this.action === 'addModule') {
				this.title = this.locale.translate('new_module');
			} else {
				this.title = this.locale.translate('edit_module');
			}
			this.popupRef.componentInstance.popupLoader = true;
			const title: TextBoxModel = {
				fieldColumn: 'moduleName',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('title'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('content_title')
			};
			const unlockAfterPreviousModule: CheckBoxModel = {
				fieldColumn: 'unlockAfterPrevious',
				additionalMetaData: {
					showLabel: true
				},
				fieldType: 'checkBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				options: [{
					key: true,
					value: this.locale.translate('unlock_after_previous')
				}],
				fieldCaption: null,
				fieldOrder: 2
			};
			const EnforceSequencingActivitiesModule: CheckBoxModel = {
				fieldColumn: 'sequenceActivities',
				additionalMetaData: {
					showLabel: true
				},
				fieldType: 'checkBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				options: [{
					key: true,
					value: this.locale.translate('enforce_sequencing_of_activities')
				}],
				fieldCaption: null,
				fieldOrder: 3
			};

			if (this.action === 'editModule') {
				if (this.record.moduleName) {
					title.value = this.record.moduleName;
					unlockAfterPreviousModule.value = [this.record.unlockAfterPrevious];
					EnforceSequencingActivitiesModule.value = [this.record.sequenceActivities];
				}
			}

			this.formFields = [
				title,
				unlockAfterPreviousModule,
				EnforceSequencingActivitiesModule
			];

			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'chooseContentType') {
			this.title = this.locale.translate('add_activity');
			this.contentType = this.baseService.courseContentType;
			this.submitDisable = false;
		} else if (this.action === 'addActivity') {
			this.popupRef.componentInstance.popupLoader = true;
			if (['learningContent', 'events', 'moocs'].includes(this.selectedContentType.key)) {
				if (this.selectedContentType.key === 'learningContent') {
					this.title = this.locale.translate('add_learning_content');
					if (this.baseService.checkAccessControl(['CON001', 'CON003'])) {
						this.showNewResource = true;
					}
				} else if (this.selectedContentType.key === 'events') {
					this.title = this.locale.translate('add_events');
					if (this.baseService.checkAccessControl(['EEV003', 'EEV001'])) {
						this.showNewResource = true;
					}
				} else if (this.selectedContentType.key === 'moocs') {
					this.title = this.locale.translate('add_moocs');
					if (this.baseService.checkAccessControl(['MOOC003', 'MOOC001'])) {
						this.showNewResource = true;
					}
				}

				// this.info = this.locale.translate('learning_content_should_be_audio_video');
				// const title: TextBoxModel = {
				// 	fieldColumn: 'title',
				// 	additionalMetaData: {
				// 		maxChar: 250,
				// 		fieldConfig: { appearance: 'standard' },
				// 		showLabel: true
				// 	},
				// 	fieldType: 'textBox',
				// 	isHidden: false,
				// 	isReadonly: false,
				// 	isRequired: true,
				// 	type: 'text',
				// 	validationRegex: null,
				// 	fieldCaption: this.locale.translate('title'),
				// 	fieldHelpText: null,
				// 	fieldOrder: 1,
				// 	validationMessage: '',
				// 	fieldPlaceholder: this.locale.translate('title')
				// };

				// const content: FileUploadModel = {
				// 	fieldCaption: this.locale.translate('content'),
				// 	fieldColumn: 'file',
				// 	validationMessage: this.locale.translate('invalid_file'),
				// 	fieldOrder: 2,
				// 	fieldType: 'fileUpload',
				// 	fieldHelpText: null,
				// 	fieldPlaceholder: this.locale.translate('drop_an_audio_video_click_image_upload'),
				// 	isRequired: true,
				// 	isHidden: false,
				// 	additionalMetaData: {
				// 		showLabel: true,
				// 		fileSize: '100MB',
				// 		supportedType: ['.mp4', '.mpeg', '.avi'],
				// 		drag: true
				// 	},
				// 	isReadonly: false,
				// 	value: null
				// };
				const title: AutoCompleteModel = {
					fieldColumn: 'title',
					additionalMetaData: {
						showLabel: true,
						autoFill: 'off'
					},
					fieldType: 'autoComplete',
					isHidden: false,
					isMultiple: false,
					isReadonly: false,
					isRequired: false,
					options: [],
					selectedValue: [],
					fieldCaption: this.locale.translate('type_title'),
					fieldOrder: 1,
					preDefined: false,
					fieldPlaceholder: this.locale.translate('type_title')
				};

				this.resourceField = [
					title,

				];
			}

			else if (this.selectedContentType.key === 'scorm') {
				this.title = this.locale.translate('add_scorm');
				if (this.baseService.checkAccessControl(['CON001', 'CON003'])) {
					this.showNewResource = true;
				}
				const title: AutoCompleteModel = {
					fieldColumn: 'title',
					additionalMetaData: {
						showLabel: true,
						autoFill: 'off'
					},
					fieldType: 'autoComplete',
					isHidden: false,
					isMultiple: false,
					isReadonly: false,
					isRequired: false,
					options: [],
					selectedValue: [],
					// fieldCaption: this.locale.translate('type_title'),
					fieldOrder: 1,
					preDefined: false,
					fieldPlaceholder: this.locale.translate('select_scorm_package')
				};

				this.resourceField = [
					title,

				];
			}

			else if (this.selectedContentType.key === 'reference') {
				this.title = this.locale.translate('add_reference');
				this.info = this.locale.translate('add_reference_info');
				const title: AutoCompleteModel = {
					fieldColumn: 'title',
					additionalMetaData: {
						showLabel: true,
						autoFill: 'off'
					},
					fieldType: 'autoComplete',
					isHidden: false,
					isMultiple: true,
					isReadonly: false,
					isRequired: false,
					options: [],
					selectedValue: [],
					fieldCaption: this.locale.translate('type_title'),
					fieldOrder: 1,
					preDefined: false,
					fieldPlaceholder: this.locale.translate('type_title')
				};

				const module: DropDownModel = {
					fieldColumn: 'module',
					fieldType: 'dropDown',
					isHidden: false,
					isMultiple: false,
					isReadonly: false,
					isRequired: true,
					options: [],
					additionalMetaData: {},
					fieldCaption: this.locale.translate('module'),
					fieldPlaceholder: this.locale.translate('module'),
					value: this.record.moduleID
				};
				if (this.record.moduleData && this.record.moduleData.length) {
					module.options = this.record.moduleData.map(resp => {
						return {
							key: resp.moduleID,
							value: resp.moduleName
						};
					});
				}
				this.formFields = [module];
				this.resourceField = [title];

			} else if (this.selectedContentType.key === 'assessment') {
				this.title = this.locale.translate('add_assessment');
				const module: DropDownModel = {
					fieldColumn: 'module',
					fieldType: 'dropDown',
					isHidden: false,
					isMultiple: false,
					isReadonly: false,
					isRequired: true,
					options: [],
					additionalMetaData: {},
					fieldCaption: this.locale.translate('module'),
					fieldPlaceholder: this.locale.translate('module'),
					value: this.record.moduleID
				};
				const assessment: AutoCompleteModel = {
					fieldColumn: 'assessmentID',
					additionalMetaData: {
						fieldConfig: { appearance: 'standard' },
						showLabel: true,
						autoFill: 'off'
					},
					fieldType: 'autoComplete',
					isHidden: false,
					isReadonly: false,
					isRequired: true,
					validationRegex: null,
					fieldCaption: this.locale.translate('assessment'),
					fieldHelpText: null,
					fieldOrder: 1,
					validationMessage: '',
					fieldPlaceholder: this.locale.translate('type_assessment'),
					isMultiple: false,
					options: [],
					selectedValue: [],
					preDefined: true
				};
				if (this.record.moduleData && this.record.moduleData.length) {
					module.options = this.record.moduleData.map(resp => {
						return {
							key: resp.moduleID,
							value: resp.moduleName
						};
					});
				}
				this.formFields = [
					module,
					assessment
				];
				// const apiData = {
				// 	termsetid: 11
				// };
				// const headers: any = {};
				// this.globalApiService.getTerm(apiData, headers).subscribe(
				// 	(response) => {
				// 		if (response && response.records.length) {
				// 			module.options = response.records.map(resp => {
				// 				return {
				// 					key: resp.termID,
				// 					value: resp.term
				// 				};
				// 			});
				// 		}
				// 	},
				// 	(error) => {
				// 		this.gfService.errorHandler(error, {
				// 			snackBar: {
				// 				position: 'before'
				// 			}
				// 		});
				// 	}
				// )
				// 	.add(() => { });
			}

			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'nominate') {
			this.title = this.locale.translate('nominate');
			this.popupRef.componentInstance.popupLoader = true;
			const nominee: AutoCompleteModel = {
				fieldColumn: 'nominee',
				additionalMetaData: {
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				validationRegex: null,
				fieldCaption: this.locale.translate('nominee_name'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('type_name'),
				isMultiple: false,
				options: [],
				selectedValue: [],
				preDefined: true
			};
			const notes: TextAreaModel = {
				fieldColumn: 'notes',
				additionalMetaData: {
					maxChar: 500,
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				validationRegex: null,
				fieldCaption: this.locale.translate('notes_if_any'),
				fieldHelpText: null,
				fieldOrder: 2,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('notes')
			};
			this.formFields = [
				nominee,
				notes
			];
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'enrollCourse') {
			this.title = this.locale.translate('request_enrollment');
			this.info = this.locale.translate('request_enrollment_info');
			const notes: TextBoxModel = {
				fieldColumn: 'notes',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('notes_if_any'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('notes_if_any')
			};
			this.formFields = [
				notes
			];
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'generateCertificate') {
			this.submitDisable = true;
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('certificate');
			this.info = this.locale.translate('certificate_generated_and_added_to_your_profile');
			const apiData = {};
			const headers: any = {};
			// this.record.certificateURL = 'https://file-examples-com.github.io/uploads/2017/10/file_example_PNG_500kB.png';
			// this.submitDisable = false;
			// this.popupRef.componentInstance.popupLoader = false;

			this.apiService.generateCertificate(apiData, this.record.resourceID, headers).subscribe(
				(response) => {
					if (response && response.certificateURL) {
						this.record.certificateURL = response.certificateURL;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			).add(() => {
				this.submitDisable = false;
				this.popupRef.componentInstance.popupLoader = false;
			});
		} else if (this.action === 'viewCertificate') {
			this.submitDisable = true;
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('certificate');
			const apiData = {};
			const headers: any = {};
			let apiMethod;
			if (this.profileCertificate) {
				apiMethod = this.peopleApiService.getCertificationDetail(apiData, this.record.resourceID, headers);
			} else {
				apiMethod = this.apiService.getCertificationDetail(apiData, this.record.resourceID, headers);
			}
			apiMethod.subscribe(
				(response) => {
					if (response && response.thumbnail) {
						this.record = {
							certificateURL: response.thumbnail
						};
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			).add(() => {
				this.submitDisable = false;
				this.popupRef.componentInstance.popupLoader = false;
			});
		} else if (this.action === 'viewAssesmentResult') {
			this.title = this.viewResultDetails.title;
			this.getUserTestDetails();
		} else if (this.action === 'viewScormReport') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.viewScormData.title;
			this.getScormReportDatails();
		} 
	}

	ngAfterViewInit() {
		if (this.infoTextEl && this.infoTextEl.nativeElement) {
			const el: HTMLElement = this.infoTextEl.nativeElement.querySelector('span');
			if (el) {
				el.addEventListener('click', this.assign.bind(this));
			}
		}
	}

	addResource() {
		let component;
		let componentData = [];
		let maxWidth = '860px';

		if (this.selectedContentType.key === 'learningContent') {
			component = ResourceFormsComponent;
			componentData.push(
				{
					variableName: 'action',
					value: 'resourceFormat'
				},
				{
					variableName: 'actionFrom',
					value: 'courseActivity'
				}
			);
			maxWidth = '600px';
		} else if (['events', 'moocs'].includes(this.selectedContentType.key)) {
			const resourceFormatData = this.baseService.resourceFormat.find(items => items.key === 'link');
			component = import('@app/modules/resource/resource-forms/resource-forms.component');
			componentData.push(
				{
					variableName: 'action',
					value: 'addResource'
				},
				{
					variableName: 'resourceFormatData',
					value: resourceFormatData
				}
			);

			if (this.selectedContentType.key === 'events') {
				componentData.push({
					variableName: 'externalEventAdd',
					value: true
				});
			} else if (this.selectedContentType.key === 'moocs') {
				componentData.push({
					variableName: 'moocAdd',
					value: true
				});
			}
		} else if (this.selectedContentType.key === 'scorm') {
			component = import('@app/modules/resource/resource-forms/resource-forms.component');
			componentData.push(
				{
					variableName: 'action',
					value: 'addScorm'
				}
			);

		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component,
				componentData
			},
			disableClose: true,
			maxWidth
		});

		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				if (this.selectedContentType.key === 'learningContent') {
					this.addSelectedResource(result);
				} else if (['events', 'moocs'].includes(this.selectedContentType.key)) {
					result.resourceID = result.recordID;
					result.createdBy = this.currentUser.userID;
					this.addSelectedResource([result]);
				}
			}
		});

	}

	tabChange(index) {
		this.tabIndex = index;
		this.users = [];
		this.limit = 10;
		this.pageNumber = 1;
		this.usersCount = 0;
		if (this.formObject) {
			this.formObject.form.controls.search.patchValue(null, { emitEvent: false });
		}
		this.getUsers();
	}

	getUsers() {
		this.loader = true;
		const headers = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		const apiData: any = {};
		if (this.formObject && this.formObject.form.controls.search.value) {
			apiData.searchString = this.formObject.form.controls.search.value;
			this.controlValue = apiData.searchString;
		} else {
			this.controlValue = null;;
		}
		if (this.tabIndex === 0) {
			apiData.type = 1;
		} else {
			apiData.type = 2;
		}
		this.apiService
			.getEnrolledUsers(apiData, this.record.resourceID, headers)
			.subscribe(
				(response) => {
					this.usersCount = 0;
					this.users = [];
					if (response && response.hasOwnProperty('records')) {
						this.usersCount = response.totalRecordCount;
						this.dataBuild(response.records);
						this.users = response.records;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
					this.usersCount = 0;
					this.users = [];
				}
			)
			.add(() => {
				this.loader = false;
			});
	}

	dataBuild(records) {
		for (const data of records) {
			const shortInfo = [];
			data.date = this.gfService.dateFormat(data.enrolmentDate, 'MMM d y');
			data.name = `${data.firstName}${data.lastName
				? ' ' + data.lastName
				: ''}`;
			data.completionDate = this.gfService.dateFormat(data.completionDate, 'MMM d y')
			if (data.company && data.company.name) {
				shortInfo.push(
					{
						value: data.company.name
					}
				);
			}
			if (data.department && data.department.name) {
				shortInfo.push(
					{
						value: data.department.name
					}
				);
			}
			if (data.city && data.city.name) {
				shortInfo.push(
					{
						value: data.city.name
					}
				);
			}
			if (data.location && data.location.name) {
				shortInfo.push(
					{
						value: data.location.name
					}
				);
			}
			data.shortInfo = shortInfo;
		}
	}

	searchPeopleDetail(data) {
		if (data && data.userID) {
			this.baseService.userDetail(data.userID);
		}
	}

	formObjectReader(record: any) {
		this.formObject = record;
		const form: UntypedFormGroup = record.form;
		let subscribe;
		if (record.form.controls.hasOwnProperty('skills')) {
			const skill = this.skillField.find((items) => items.fieldColumn === 'skills');
			form.controls.skills.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 1
							};
							const header: any = {};
							let selectedValue = [];
							if (skill.selectedValue.length) {
								skill.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.termID)) {
													return items;
												}
											});
										}
										skill.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										skill.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									skill.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								skill.options = [];
							} else {
								// this.loadMySkills(skill);
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		} else if (record.form.controls.hasOwnProperty('prerequisiteSkills')) {
			const prerequisiteSkills = this.preRequisiteField.find((items) => items.fieldColumn === 'prerequisiteSkills');
			form.controls.prerequisiteSkills.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 1
							};
							const header: any = {};
							let selectedValue = [];
							if (prerequisiteSkills.selectedValue.length) {
								prerequisiteSkills.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.termID)) {
													return items;
												}
											});
										}
										prerequisiteSkills.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										prerequisiteSkills.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									prerequisiteSkills.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								prerequisiteSkills.options = [];
							} else {
								// this.loadMySkills(prerequisiteSkills);
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		} else if (this.action === 'addEnrollUsers') {
			const enrollUserField = this.formFields.find((items) => items.fieldColumn === 'enrolUserID');

			form.controls.enrolUserID.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData: any = {
								searchString: controlResp,
								includeWorkGroup: 1
							};
							const header: any = {};
							let selectedUser = [];
							if (enrollUserField.selectedValue.length) {
								enrollUserField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete && !items.key.isWorkGroup) {
										selectedUser.push(items.key.ID);
									}
								});
							}
							let selectedWorkgroup = [];
							if (enrollUserField.selectedValue.length) {
								enrollUserField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete && items.key.isWorkGroup) {
										selectedWorkgroup.push(items.key.ID);
									}
								});
							}
							subscribe = this.globalApiService.getWorkGroupUsers(apiData, header).subscribe(
								(response) => {
									if (response) {
										if (selectedUser.length) {
											response.records = response.records.filter(items => {
												if (!selectedUser.includes(items.userID)) {
													return items;
												}
											});
										}
										if (selectedWorkgroup.length) {
											if (response.workgroup && response.workgroup.length) {
												response.workgroup = response.workgroup.filter(items => {
													if (!selectedWorkgroup.includes(items.groupID)) {
														return items;
													}
												});
											}
										}
										let options = [];
										if (response.workgroup && response.workgroup.length) {
											options = response.workgroup.map((data) => {
												return {
													key: {
														ID: data.groupID,
														isWorkGroup: true
													},
													value: data.groupName,
													prefix: {
														type: 'svgIcon',
														value: 'workgroup'
													}
												};
											});
										}
										options = options.concat(response.records.map((data) => {
											return {
												key: {
													ID: data.userID,
													isWorkGroup: false
												},
												value: `${data.firstName}${data.lastName
													? ' ' + data.lastName
													: ''}`,
												prefix: {
													type: 'image',
													value: data.profilePicURL
												},
												shortInfo: this.baseService.getUserShortInfo(data)
											};
										}));
										enrollUserField.options = options;
									} else {
										enrollUserField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									enrollUserField.options = [];
								}
							);
						} else {
							enrollUserField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});

		} else if (form.controls.hasOwnProperty('title') && this.action === 'addActivity' && ['reference', 'learningContent', 'events', 'moocs', 'scorm'].includes(this.selectedContentType.key)) {
			let subscribe;
			const titleField = record.fields.find((items) => items.fieldColumn === 'title');
			form.controls.title.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					if (controlResp && typeof controlResp === 'object' && controlResp.isAdd) {
						this.addSelectedResource([controlResp.key]);
					}
					if (controlResp && typeof controlResp === 'object') {
						titleField.selectedValue = [];
						form.controls.title.patchValue(null, { emitEvent: false });
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {

							let selectedValue = [];
							this.selectedResources.map(items => {
								selectedValue.push(items.resourceID);
							});
							const apiData: any = {
								searchString: controlResp,
								resource: []
							};
							const header: any = {
								lanCode: sessionStorage.getItem('locale') || 'en'
							};
							if (this.record && this.record.moduleData && this.record.moduleData.length) {
								const module = this.record.moduleData.find(items => items.moduleID === this.record.moduleID);
								if (module) {
									let moduleData = [];
									let id;
									if (this.selectedContentType.key === 'reference') {
										moduleData = module.references;
										id = 'resourceID';
									} else {
										moduleData = module.activites;
										id = 'id';
									}
									const selectedIDs = moduleData.map(data => { return data[id] });
									selectedValue = selectedValue.concat(selectedIDs);
								}
							}
							if (this.selectedContentType.key === 'learningContent') {
								apiData.reportType = 'LEARNING_CONTENT';
							} else if (this.selectedContentType.key === 'events') {
								apiData.reportType = 'EVENTS';
								apiData.expiry = 1;
							} else if (this.selectedContentType.key === 'moocs') {
								apiData.reportType = 'MOOC';
							}
							else if (this.selectedContentType.key === 'scorm') {
								apiData.reportType = 'SCORM';
							}

							apiData.resource = selectedValue;
							
							subscribe = this.globalApiService.searchByResource(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										titleField.options = [];
										for (const record of response.records) {
											titleField.options.push(
												{
													key: record,
													value: record.title
												}
											);
										}

									} else {
										titleField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									titleField.options = [];
								}
							);
						} else {
							titleField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		} else if (this.action === 'nominate') {
			const nomineeField = record.fields.find((items) => items.fieldColumn === 'nominee');
			let subscribe;
			form.controls.nominee.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							// const userFilter: any = { $and: [] };
							// const splitVal = controlResp.toLowerCase().split(' ');
							// for (const value of splitVal) {
							//   userFilter.$and.push({
							//     $or: {
							//       '$accountDetail.firstName$': { $substring: value },
							//       '$accountDetail.lastName$': { $substring: value }
							//     }
							//   });
							// }
							const apiData = {
								searchString: controlResp
							};
							const header: any = {};
							let selectedValue = [];
							if (this.record && this.record.authors && this.record.authors.length) {
								for (const author of this.record.authors) {
									selectedValue.push(author.userID);
								}
							}
							subscribe = this.globalApiService.getWorkGroupUsers(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.userID)) {
													return items;
												}
											});
										}
										nomineeField.options = response.records.map((data) => {
											return {
												key: data.userID,
												value: `${data.firstName}${data.lastName
													? ' ' + data.lastName
													: ''}`,
												prefix: {
													type: 'image',
													value: data.profilePicURL
												},
												shortInfo: this.baseService.getUserShortInfo(data)
											};
										});
									} else {
										nomineeField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									nomineeField.options = [];
								}
							);
						} else {
							nomineeField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		} else if (record.form.controls.channel) {
			let subscribe;
			const channelField = this.visibilityField.find((items) => items.fieldColumn === 'channel');
			form.controls.channel.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp
							};
							const header: any = {};
							let selectedValue = [];
							if (channelField.selectedValue.length) {
								channelField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.channelsApiService.getChannelList(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.channelID)) {
													return items;
												}
											});
										}
										channelField.options = response.records.map((data) => {
											return {
												key: data.channelID,
												value: data.channelName
											};
										});
									} else {
										channelField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									channelField.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								channelField.options = [];
							} else {
								this.loadChannel(channelField);
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
	}

	async addSelectedResource(resources) {
		for (const resource of resources) {

			let finalData: any = {};
			if (resource.resourceTypeID) {
				resource.resourceType = this.baseService.referenceType('resourceType', resource.resourceTypeID);
				if (resource.resourceType.key === 'answer') {
					const cardData: QuestionCard = {
						title: resource.title,
						// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
						thumbnail: '',
						removable: true
					};
					// if (data.authors && data.authors.length) {
					// 	cardData.thumbnail = data.authors[0].profilePicURL;
					// 	cardData.creator = `${data.authors[0].firstName}${data.authors[0].lastName
					// 		? ' ' + data.authors[0].lastName
					// 		: ''}`;
					// 	if (data.authors.length > 1) {
					// 		cardData.usersCount = (data.authors.length - 1);
					// 	}
					// }

					finalData = cardData;
				} else if (resource.resourceType.key === 'playlist') {
					const cardData: PlaylistCard = {
						title: resource.title,
						// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
						// type: resource.resourceType.caption,
						thumbnail: '',
						removable: true
						// playlistItemCount: data.count
					};

					finalData = cardData;
				} else if (['internalEvent', 'externalEvent'].includes(resource.resourceType.key)) {
					const cardData: EventCard = {
						thumbnail: '',
						title: resource.title,
						eventType: (resource.resourceType && resource.resourceType.key) ? resource.resourceType.key : null,
						removable: true
					};
					if (resource.resourceType) {
						// if (data.infoFields) {
						// 	if (data.resourceType.key === 'internalEvent') {
						// 		if (data.infoFields.time) {
						// 			cardData.time = this.gfService.dateFormat(data.infoFields.time, 'shortTime');
						// 		}
						// 		if (data.infoFields.date.length) {
						// 			cardData.date = `${this.gfService.dateFormat(data.infoFields.date[0], 'd')} ${this.gfService.dateFormat(data.infoFields.date[0], 'MMM')} - ${this.gfService.dateFormat(data.infoFields.date[1], 'd')} ${this.gfService.dateFormat(data.infoFields.date[1], 'MMM')}`;
						// 		}
						// 	} else {
						// 		if (data.infoFields.date) {
						// 			cardData.date = this.gfService.dateFormat(data.infoFields.date, 'd MMM');
						// 		}
						// 	}
						// }
					}

					finalData = cardData;
				} else {
					const cardData: ContentImageCard = {
						title: resource.title,
						// date: this.gfService.dateFormat(resource.createdAt, 'MMM d, y'),
						thumbnail: '',
						removable: true
					};
					finalData = cardData;

				}

				finalData.type = resource.resourceType.caption;
			}

			if (resource.resource && resource.resource.hasOwnProperty('duration')) {
				finalData.duration = resource.resource.duration;
			}

			// if (resource.description) {
			// 	cardData.description = resource.description;
			// 	}
			if (resource.resourceType && resource.resourceType.key !== 'answer') {
				if (resource.resource && resource.resource.thumbnail) {
					finalData.thumbnail = resource.resource.thumbnail;
				} else if (resource.thumbnail instanceof File) {
					finalData.thumbnail = await this.gfService.fileToDataURL(resource.thumbnail);
				}
			}
			if (resource.resourceFormat) {
				resource.resourceFormat = this.baseService.referenceType('resourceFormat', resource.resourceFormat);
				finalData.format = resource.resourceFormat.key;
				if (finalData.thumbnail === '') {
					finalData.thumbnail = resource.resourceFormat.image;
				}
			}

			const extraData: any = {
				resourceID: resource.resourceID,
				createdBy: resource.createdBy,
				includeScore: false
			};

			if (resource.resource) {
				extraData.resource = resource.resource;
			}

			if (resource.resourceFormat) {
				extraData.resourceFormat = resource.resourceFormat;
			}

			if (resource.resourceType) {
				extraData.resourceTypeID = resource.resourceType;
			}

			if (resource.description) {
				extraData.description = resource.description;

			}

			this.selectedResources.push(this.gfService.JSONMerge(finalData, extraData));

		}

	}


	removeResource(index) {
		if (navigator.onLine) {
			this.selectedResources.splice(index, 1);
		}
	}

	// loadMySkills(skills) {
	// 	const apiData = {};
	// 	const headers: any = {};
	// 	skills.options = [];
	// 	this.globalApiService.getMySkills(apiData, headers).subscribe(
	// 		(response) => {
	// 			if (response && Array.isArray(response.records)) {
	// 				skills.options = response.records.map(resp => {
	// 					return {
	// 						key: resp.skill,
	// 						value: resp.skillName
	// 					};
	// 				});
	// 			}
	// 		},
	// 		(error) => {
	// 			this.gfService.errorHandler(error, {
	// 				snackBar: {
	// 					position: 'before'
	// 				}
	// 			});
	// 		}
	// 	)
	// 		.add(() => {
	// 		});
	// }

	searched() {
		if (navigator.onLine) {
			this.pageNumber = 1;
			this.usersCount = 0;
			this.loader = true;
			this.getUsers();
		}
	}

	clear() {
		if (navigator.onLine) {
			this.pageNumber = 1;
			this.usersCount = 0;
			this.loader = true;
			this.getUsers();
		}
	}

	pagination(pageEvent) {
		this.limit = pageEvent.limit;
		this.pageNumber = pageEvent.pageNumber;
		this.getUsers();
	}

	loadResource(data) {
		// this.gfService.blockHttpCall = false;
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel', 'advanced-content'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: import('@app/modules/resource/resource-detail/resource-detail.component'),
				componentData: [
					{
						variableName: 'actualResourceID',
						value: data.resourceID
					},
					{
						variableName: 'actionFrom',
						value: data.actionFrom
					}
				]
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
			}
		});
	}

	addUsers(event, action: string) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: action
					},
					{
						variableName: 'record',
						value: this.record
					}
				],
				triggerEl: event
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				this.tabChange(0);
			}
		});
	}

	submit() {
		if (navigator.onLine) {
			if (this.action === 'moderate') {
				this.moderate();
			} else if (this.action === 'addCourse' || this.action === 'editCourse') {
				this.createCourse(this.action);
			} else if (this.action === 'addEnrollUsers') {
				this.saveEnrollUsers();
			} else if (this.action === 'addModule') {
				this.addModule();
			} else if (this.action === 'editModule') {
				this.updateModule();
			} else if (this.action === 'addActivity') {
				this.addActivity();
			} else if (this.action === 'nominate') {
				this.addNominee();
			} else if (this.action === 'enrollCourse') {
				this.enroll();
			}

		}
	}

	createCourse(action) {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('courseAlert');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;

				const headers: any = {};
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);

				const skills = [];
				if (formValue.skills) {
					for (const skill of formValue.skills) {
						if (!skill.value && skill.isAdd && !skill.isDelete) {
							skills.push({
								skill: skill.key,
								skillLevel: skill.progress
							});
						} else if (skill.value) {
							if (skill.value.isAdd && !skill.value.isDelete) {
								const skillData: any = { skillName: skill.value.value };
								if (skill.value.progress) {
									skillData.skillLevel = skill.value.progress;
								}
								skills.push(skillData);
							}
						}
					}
				}

				if (Array.isArray(formValue.enforcePrequisites)) {
					if (formValue.enforcePrequisites[0] !== null) {
						formValue.enforcePrequisites = formValue.enforcePrequisites[0];
					} else {
						formValue.enforcePrequisites = false;
					}
				}
				const prerequisiteSkills = [];
				if (formValue.prerequisiteSkills) {
					for (const preRequisiteSkill of formValue.prerequisiteSkills) {
						if (!preRequisiteSkill.value && preRequisiteSkill.isAdd && !preRequisiteSkill.isDelete) {
							prerequisiteSkills.push({
								skill: preRequisiteSkill.key,
								skillLevel: preRequisiteSkill.progress
							});
						} else if (preRequisiteSkill.value) {
							if (preRequisiteSkill.value.isAdd && !preRequisiteSkill.value.isDelete) {
								const preRequisiteSkillData: any = { skillName: preRequisiteSkill.value.value };
								if (preRequisiteSkill.value.progress) {
									preRequisiteSkillData.skillLevel = preRequisiteSkill.value.progress;
								}
								prerequisiteSkills.push(preRequisiteSkillData);
							}
						}
					}
				}
				formValue.skills = skills;

				if (!formValue.thumbnail || (formValue.thumbnail && !(formValue.thumbnail instanceof File))) {
					delete formValue.thumbnail;
				}
				formValue.authors = [
					{
						id: this.currentUser.userID
					}
				];

				formValue.lanCode = this.languageCode;
				let hourss;
				let mints;
				let inmint;
				if (formValue.durationInhrs) {
					hourss = Number(formValue.durationInhrs.split(':')[0]);
					mints = Number(formValue.durationInhrs.split(':')[1]);
					inmint = (hourss * 60) + mints;
				}
				formValue.durationInhrs = inmint;
				// formValue.durationInhrs = this.gfService.getTimeToSeconds(formValue.durationInhrs, { duration: 'minutes' });

				if (this.action === 'editCourse') {
					delete formValue.authors;
					// formValue.infoFields = {
					// 	course: {
					// 		enrolment: formValue.enrolment,
					// 		minScoreForCertification: formValue.minScoreForCertification,
					// 		courseDurationInHrs: formValue.durationInhrs,
					// 		prerequisiteSkills: prerequisiteSkills,
					// 	},
					// 	courseModules: this.resourceDetail.infoFields.courseModules
					// };
					// delete formValue.durationInhrs;
				} else {
					formValue.prerequisiteSkills = prerequisiteSkills;
					formValue.enrolment = formValue.enrolment;
				}
				let formData;
				formData = this.gfService.convertToFormData(formValue);
				let method = this.apiService.saveCourse(formData, headers);
				let msg = 'course_created';
				if (this.action === 'editCourse') {
					msg = 'course_updated';
					method = this.apiService.updateCourse(formData, this.record.resourceID, headers);
				}
				method.subscribe(
					async (response) => {
						if (response) {
							// if (formValue.thumbnail) {
							// 	formValue.resource = {
							// 		thumbnail: await this.gfService.fileToDataURL(formValue.thumbnail)
							// 	};
							// }
							this.popupRef.close(this.gfService.JSONMerge(formValue, response));
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate(msg),
								icon: 'check_circle_outline',
								position: 'before'
							});
							// if (this.baseService.checkAccessControl('P07') && this.action === 'addCourse') {
							// 	this.loadResource({ resourceID: response.recordID, actionFrom: 'course_all' });
							// }
						}
					},
					(error) => {
						this.gfService.alertHandler(error, 'courseAlert', 'ERROR');
						this.gfService.formErrorHandler(error, this.formObjectData.form);
					}
				)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	moderate() {
		if (this.formObject && this.formObject.form) {
			this.gfService.alertClear('manageForm');
			this.submitDisable = true;
			if (this.formObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const apiData = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				let msg;
				if (this.record.action === 'approve') {
					apiData.status = 1;
					msg = this.locale.translate('approved');
				} else if (this.record.action === 'decline') {
					apiData.status = 2;
					msg = this.locale.translate('declined');
				}
				const headers: any = {};
				this.apiService.moderate(apiData, this.record.courseID, this.record.userID, headers)
					.subscribe(
						(response) => {
							if (response) {
								this.popupRef.close(this.gfService.JSONMerge(apiData, response.recordID));
								this.gfService.openSnackBar('SUCCESS', {
									message: msg,
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							this.gfService.errorHandler(error, {
								alert: {
									id: 'manageForm'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	saveEnrollUsers() {
		if (this.formObject && this.formObject.form) {
			this.gfService.alertClear('manageForm');
			this.submitDisable = true;
			if (this.formObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formData = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				const userIds = [];
				for (const data of formData.enrolUserID) {
					if (data.isAdd && !data.isDelete && !data.key.isWorkGroup) {
						userIds.push(data.key.ID);
					}
				}
				const workgroupID = [];
				for (const data of formData.enrolUserID) {
					if (data.isAdd && !data.isDelete && data.key.isWorkGroup) {
						workgroupID.push(data.key.ID);
					}
				}
				const apiData = {
					enrolUserID: userIds,
					workgroup: workgroupID
				};
				const headers: any = {};
				this.apiService.saveEnrollUsers(apiData, this.record.resourceID, headers)
					.subscribe(
						(response) => {
							if (response) {
								let message = '';
								if (response.enroledUserCount === 0) {
									message = 'no_enrolled_users_saved';
								} else if (response.enroledUserCount === apiData.enrolUserID.length) {
									message = 'enroll_users_saved';
								} else if (response.enroledUserCount < apiData.enrolUserID.length) {
									message = 'no_enrolled_users_saved';
								}
								this.popupRef.close(apiData);
								this.gfService.openSnackBar('SUCCESS', {
									message: this.handleBarPipe.transform(this.locale.translate(message), {
										currentIndex: response.enroledUserCount,
										childLength: apiData.enrolUserID.length,
										remainingIndex: (apiData.enrolUserID.length - response.enroledUserCount)
									}),
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'EMPTY_USERID_OR_WORKGROUPID') {
								error.error = this.locale.translate('workgroup_has_no_users');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'manageForm'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	openActivity(data) {
		if (['learningContent', 'reference', 'events', 'moocs', 'scorm'].includes(data.key)) {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				data: {
					action: 'dynamic',
					popup: true,
					component: CourseFormsComponent,
					componentData: [
						{
							variableName: 'action',
							value: 'addActivity'
						},
						{
							variableName: 'selectedContentType',
							value: data
						},
						{
							variableName: 'record',
							value: this.record
						}
					]
				},
				disableClose: true,
				maxWidth: '860px'
			});
			dialogRef.afterClosed().subscribe((result) => {
				if (result && typeof result === 'object') {
					this.record = result;
					this.popupRef.componentInstance.dialogCloseData = this.record;
				}
			});
		} else if (data.key === 'assessment') {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				data: {
					action: 'dynamic',
					popup: true,
					component: AssessmentFormsComponent,
					componentData: [
						{
							variableName: 'action',
							value: 'createTest'
						},
						{
							variableName: 'record',
							value: this.record
						}
					]
				},
				disableClose: true,
				maxWidth: '860px'
			});
			dialogRef.afterClosed().subscribe((result) => {
				if (result && typeof result === 'object') {
					this.addQuestionDistribution(result.recordID);
				}
			});
		}
	}

	addQuestionDistribution(assessmentID) {
		let moduleIndex;
		this.record.moduleData.find((items, index) => {
			if (items.moduleID === this.record.moduleID) {
				moduleIndex = index;
				return;
			}
		});

		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: AssessmentFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'questionDistribution'
					},
					{
						variableName: 'assessmentID',
						value: assessmentID
					},
					{
						variableName: 'coveredSkills',
						value: this.record.skills
					},
					{
						variableName: 'courseDetails',
						value: {
							resource: this.resourceDetail,
							moduleIndex
						}
					}
				]
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object' && result.testData) {
				const value = this.baseService.courseContentType.find(items => items.key === 'assessment');
				const pushJson = {
					id: result.testData.testID,
					index: this.record.activites.length + 1,
					type: value.value,
					title: result.testData.name,
					contentType: value
				};
				this.record.moduleData[moduleIndex].activites.push(pushJson);
				// this.record.moduleData.find(items => {
				// 	if (items.moduleID === this.record.moduleID) {
				// 		items.activites.push(pushJson);
				// 	}
				// });
			}
		});
	}

	enroll() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('courseAlert');
			if (this.formObjectData.form.valid) {
				const apiData = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				apiData.notificationType = 1;
				if (this.deviceDetails.browserName === 'Safari') {
					apiData.notificationType = 2;
				}
				this.popupRef.componentInstance.popupLoader = true;
				this.apiService.enroll(apiData, this.record.resourceID, headers).subscribe(
					(response) => {
						this.baseService.logUserActivity('requestregistration', 'learning', [''], { resourceData: this.record });
						let msg = 'course_enrolled';
						if (response) {
							if (response.statusCode === 'ENROLMENT_CREATED') {
								msg = 'course_enrolled';
							} else if (response.statusCode === 'ENROLMENT_REQUEST_CREATED') {
								msg = 'enrolment_request_has_been_sent';
							}
						}
						this.popupRef.close(this.gfService.JSONMerge(apiData, response));
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate(msg),
							icon: 'check_circle_outline',
							position: 'before'
						});
					},
					(error) => {
						this.gfService.errorHandler(error, {
							alert: {
								id: 'courseAlert'
							},
							form: this.formObjectData.form
						});
					}
				)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}

		}
	}

	addModule() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('courseAlert');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				let moduleData = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				if (Array.isArray(moduleData.unlockAfterPrevious)) {
					if (moduleData.unlockAfterPrevious[0] !== null) {
						moduleData.unlockAfterPrevious = moduleData.unlockAfterPrevious[0];
					} else {
						moduleData.unlockAfterPrevious = false;
					}
				}
				if (Array.isArray(moduleData.sequenceActivities)) {
					if (moduleData.sequenceActivities[0] !== null) {
						moduleData.sequenceActivities = moduleData.sequenceActivities[0];
					} else {
						moduleData.sequenceActivities = false;
					}
				}
				const apiData: any = moduleData;
				this.apiService
					.addModule(apiData, this.record.resourceID, headers)
					.subscribe(
						(response) => {
							this.popupRef.close(this.gfService.JSONMerge(apiData, response));
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate('module_added'),
								icon: 'check_circle_outline',
								position: 'before'
							});
						},
						(error) => {
							this.gfService.errorHandler(error, {
								alert: {
									id: 'courseAlert'
								},
								form: this.formObjectData.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	updateModule() {
		if (this.formObjectData && this.formObjectData.form) {
			this.gfService.alertClear('courseAlert');
			this.submitDisable = true;
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				if (Array.isArray(formValue.unlockAfterPrevious)) {
					if (formValue.unlockAfterPrevious[0] !== null) {
						formValue.unlockAfterPrevious = formValue.unlockAfterPrevious[0];
					} else {
						formValue.unlockAfterPrevious = false;
					}
				}
				if (Array.isArray(formValue.sequenceActivities)) {
					if (formValue.sequenceActivities[0] !== null) {
						formValue.sequenceActivities = formValue.sequenceActivities[0];
					} else {
						formValue.sequenceActivities = false;
					}
				}

				const apiData = {
					title: formValue.moduleName,
					unlockAfterPrevious: formValue.unlockAfterPrevious,
					sequenceActivities: formValue.sequenceActivities,

				};
				const headers: any = {};
				this.apiService
					.updateModule(apiData, this.record.resourceID, this.record.moduleID, headers)
					.subscribe(
						(response) => {
							if (response) {
								this.popupRef.close(formValue);
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('module_updated'),
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							this.gfService.errorHandler(error, {
								alert: {
									id: 'courseAlert'
								},
								form: this.formObjectData.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	addActivity() {
		if (['learningContent', 'events', 'moocs', 'scorm'].includes(this.selectedContentType.key)) {
			this.addLearningContent();
		} else if (this.selectedContentType.key === 'reference') {
			this.addReference();
		}
	}

	addLearningContent() {
		if (this.selectedResources && this.selectedResources.length) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('courseAlert');
			this.popupRef.componentInstance.popupLoader = true;
			const resources = [];
			const apiData: any = {};

			for (const resource of this.selectedResources) {
				;
				if (resource.resourceFormat.key === 'scorm') {
					resources.push({ resourceID: resource.resourceID, includeScore: resource.includeScore });
				} else {
					resources.push({ resourceID: resource.resourceID });
				}
			}
			if (resources.length > 0) {
				apiData.resources = resources;
			}

			this.apiService.addLearningContent(apiData, this.record.resourceID, this.record.moduleID, headers).subscribe(
				(response) => {

					const value = this.baseService.courseContentType.find(items => items.key === this.selectedContentType.key);
					const data = [];
					for (const resource of this.selectedResources) {
						data.push(
							{
								id: resource.resourceID,
								index: this.record.activites.length + 1,
								type: value.value,
								title: resource.title,
								contentType: value,
								resourceFormat: resource.resourceFormat,
								resourceTypeID: resource.resourceTypeID,
								includeScore: resource.includeScore
							}
						);
					}
					this.record.moduleData.find(items => {
						if (items.moduleID === this.record.moduleID) {
							const activites = [];
							for (const resourceData of data) {
								let isExisted = false;
								if (items.activites) {
									for (const activity of items.activites) {
										if (resourceData.id === activity.id) {
											isExisted = true;
										}
									}
								}
								if (!isExisted) {
									activites.push(resourceData);
								}
							}
							items.activites = items.activites.concat(activites);
						}
					});
					this.popupRef.close(this.record);
					let msg = 'learning_content_added';
					if (this.selectedContentType.key === 'events') {
						msg = 'events_added';
					} else if (this.selectedContentType.key === 'events') {
						msg = 'moocs_added';
					} else if (this.selectedContentType.key === 'scorm') {
						msg = 'scorm_added'
					}
					this.gfService.openSnackBar('SUCCESS', {
						message: this.locale.translate(msg),
						icon: 'check_circle_outline',
						position: 'before'
					});
				},
				(error) => {
					this.gfService.errorHandler(error, {
						alert: {
							id: 'courseAlert'
						},
						form: this.formObject.form
					});
				}
			)
				.add(() => {
					this.submitDisable = false;
					this.popupRef.componentInstance.popupLoader = false;
				});
		} else {
			this.gfService.errorHandler({ error: this.locale.translate('select_atleast_one_resource') }, {
				alert: {
					id: 'courseAlert'
				}
			});
		}
	}

	addReference() {
		if (this.formObjectData && this.formObjectData.form && this.selectedResources.length) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('courseAlert');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				let formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				const apiData: any = {};

				if (this.selectedResources.length) {
					const referenceID = [];
					for (const resource of this.selectedResources) {
						referenceID.push(resource.resourceID);
					}
					if (referenceID.length > 0) {
						apiData.referenceID = referenceID;
					}
				}

				this.apiService
					.addReference(apiData, this.record.resourceID, formData.module, headers)
					.subscribe(
						(response) => {
							this.record.moduleData.find(items => {
								if (items.moduleID === formData.module) {
									if (items.references && items.references.length) {
										items.references = items.references.concat(this.selectedResources);
									} else {
										items.references = this.selectedResources
									}
								}
							});
							this.popupRef.close(this.record);
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate('reference_added'),
								icon: 'check_circle_outline',
								position: 'before'
							});
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
								error.error = this.locale.translate('the_reference_being_added_already_exists');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'courseAlert'
								},
								form: this.formObjectData.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		} else if (!this.selectedResources.length) {
			this.gfService.errorHandler({ error: this.locale.translate('select_atleast_one_resource') }, {
				alert: {
					id: 'courseAlert'
				},
				form: this.formObjectData.form
			});
		}
	}

	addNominee() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('courseAlert');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				let formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				let apiData = {
					remarks: formData.notes
				};
				let userID;
				for (const data of formData.nominee) {
					if (data.isAdd && !data.isDelete) {
						userID = data.key;
					}
				}
				this.apiService
					.addNominee(apiData, this.record.resourceID, userID, headers)
					.subscribe(
						(response) => {
							this.baseService.logUserActivity('nominateuser', 'engagement', [''], { resourceData: this.record });
							this.popupRef.close(apiData);
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate('nominee_added'),
								icon: 'check_circle_outline',
								position: 'before'
							});
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === "DUPLICATE") {
								error.error = this.locale.translate('user_already_nominated_for_this_course');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'courseAlert'
								},
								form: this.formObjectData.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	assign() {
		this.popupRef.close(null);
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: AssignmentUpdateComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'assign'
					},
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					}
				]
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: true
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				// if (!this.assignmentDetail) {
				// 	this.reloadAssignment = true;
				// }
				// if (result.assignee && Array.isArray(result.assignee) && this.features && this.features.stats && this.features.stats.hasOwnProperty('assignedCount')) {
				// 	this.features.stats.assignedCount = this.features.stats.assignedCount + result.assignee.length;
				// }
			}
		});
	}

	courseProgressDetail(data) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseProgressComponent,
				componentData: [
					{
						variableName: 'actualResourceID',
						value: data.courseID
					},
					{
						variableName: 'userData',
						value: data
					}
				]
			},

			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
			}

		});
	}

	getUserTestDetails() {
		let apiData: any = {};
		const headers = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		this.apiService.getUserTestDetails(apiData, Number(this.viewResultDetails.id), headers, this.userData.userID)
			.subscribe((response) => {
				if (response && response.records && response.records.length) {
					this.assesmentTestDetails = response.records[0];
					if (Array.isArray(this.assesmentTestDetails.questions)) {
						this.testResultDetails = this.assesmentTestDetails.questions;
						this.scoredPercetageAssesment = this.assesmentTestDetails.scoredPoint * 100 / this.assesmentTestDetails.testDetail.totalPoints;
					}
				} else {
					this.loader = false;
					this.gfService.openSnackBar('ERROR', {
						message: this.locale.translate('no_data_found'),
						icon: 'clear',
						position: 'before'
					});
				}
			}, (error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			})
	}

	loadChannel(channelField) {
		channelField.options = [];
		const apiData = {};
		const headers: any = {};

		let selectedValue = [];
		if (channelField.selectedValue.length) {
			channelField.selectedValue.map(items => {
				if (items.isAdd && !items.isDelete) {
					selectedValue.push(items.key);
				}
			});
		}
		this.channelsApiService.getChannelList(apiData, headers).subscribe(
			(response) => {
				if (response && response.records.length) {
					if (selectedValue.length) {
						response.records = response.records.filter(items => {
							if (!selectedValue.includes(items.channelID)) {
								return items;
							}
						});
					}
					channelField.options = response.records.map((data) => {
						return {
							key: data.channelID,
							value: data.channelName
						};
					});
				}

			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		);
	}

	getScormReportDatails(){
		let apiData: any = {};
		const headers: any = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		this.apiService.getScormReport(apiData, Number(this.viewScormData.id), headers, this.userData.userID)
			.subscribe((response) => {
				if (response && response.data) {
					this.scormReportTable(response);
					this.scormScore = response.data.scoredPoint;
					this.popupRef.componentInstance.popupLoader = false;
					this.loader = false;
					
				} else {
					this.loader = false;
					this.popupRef.componentInstance.popupLoader = false;
					this.gfService.openSnackBar('ERROR', {
						message: this.locale.translate('no_data_found'),
						icon: 'clear',
						position: 'before'
					});
				}
			}, (error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			})
	}

	scormReportTable(records){
			const datasets: any = [];
			for (const key in records.data) {
				if (key === 'startDate' || key === 'endDate') {
					records.data[key] = this.gfService.dateFormat(records.data[key], 'MMM d, y')
					console.log(records.data, "records.data");
				} 
				if (key === 'status' && records.data[key] === 1) {
					records.data[key] = 'Completed'
				} else if (key === 'status' && records.data[key] === 0) {
					records.data[key] = 'Not Completed'
				}
				const data = [];
				data.push(key, records.data[key]);
				datasets.push({data})
			}
			if (!this.scormReport) {
				this.scormReport = {
					graph: {
						datasets,
						barPosition: [],
						labels: [this.locale.translate('element'), this.locale.translate('value')]
					}
				};
			} else {
				this.scormReport.graph.datasets = this.scormReport.graph.datasets.concat(datasets);
			}
	}
}
